import { render, staticRenderFns } from "./pwa_seo.vue?vue&type=template&id=8dfc154c&scoped=true&"
import script from "./pwa_seo.vue?vue&type=script&lang=js&"
export * from "./pwa_seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfc154c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dfc154c')) {
      api.createRecord('8dfc154c', component.options)
    } else {
      api.reload('8dfc154c', component.options)
    }
    module.hot.accept("./pwa_seo.vue?vue&type=template&id=8dfc154c&scoped=true&", function () {
      api.rerender('8dfc154c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/seo/pwa_seo.vue"
export default component.exports